import { render, staticRenderFns } from "./MentionList.vue?vue&type=template&id=066c0179&scoped=true&"
import script from "./MentionList.vue?vue&type=script&lang=js&"
export * from "./MentionList.vue?vue&type=script&lang=js&"
import style0 from "./MentionList.vue?vue&type=style&index=0&id=066c0179&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c0179",
  null
  
)

export default component.exports